import React, { useState, useEffect } from "react";
import {
  Toolbar,
  Grid,
  Button,
  Card,
  CardContent,
  TextField,
} from "@material-ui/core";
import Colors from "shared/color";
import Header from "components/navigation/Header";
import { GlobalHeader } from "components/navigation/components/GlobalHeader";
import BreadcrumbsHeader from "components/navigation/BreadcrumbsHeader";
import CustomInput from "components/custom/CustomInput";
import KisshtTable from "components/table/KisshtTable";
import CustomSelect from "components/custom/CustomSelect";
import { DatePicker } from "@material-ui/pickers";
import { fetchEmandateList } from "shared/api/emandate";
import { BootstrapBadge } from "components/ui/BootstrapBadge";
import {
  toastSuccess,
  DateHandle,
  filterValidation,
} from "shared/utils";
import KisshtLink from "components/ui/KisshtLink";
import { ROUTES_VAR, PERMISSIONS, ROUTE_NAME } from "shared/constants";

let offset = 1;

const EmandateRegistration = (props) => {
  const [spinning, setSpinning] = useState(false);
  const [emandateData, setEmdateData] = useState([]);
  const [emdateCount, setEmandateDataCount] = useState([]);
  const { params, updateQueryParams, delteQueryParams } = props;
  const [reload, setReload] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [authmode, setAuthMode] = useState();
  const [search, setSearch] = useState(params["search"] || "");
  const [errorMessage, setErrorMessage] = useState("");
  const [status, setstatus] = useState(params["status"] || "");
  const [selected, setSelected] = useState(params["selected"] || "");


  useEffect(() => {
    if (selected || status || search ) 
      fetchEmandateListing();
      setSearch("")
      offset=1
  }, [reload]);
  const fetchEmandateListing = async () => {
    setSpinning(true);
    await updateQueryParams({ search });
    let jsonParams = {
      from_date: fromDate,
      to_date: toDate,
      status: status,
      offset: offset - 1,
      limit: "20",
      auth_method: authmode,
    };
    await fetchEmandateList(selected, search, jsonParams)
      .then((res) => {
        setSpinning(false);
        setEmdateData([]);
        if (res.hasOwnProperty("success") && res.success) {
          if (res?.data?.emandate?.length > 0) {
            setEmdateData(res?.data?.emandate);
            setEmandateDataCount(res?.data?.count);
          } else {
            setEmdateData([]);
          }
        }
      })
      .catch((data) => {
        toastSuccess(data.message);
        setEmdateData([]);
        setSpinning(false);
      });
  };
  const columns = [
    {
      Header: "Transaction Reference Number",
      accessor: "transaction_reference_number",
      sortable: false,
      headerClassName: "common_medium_tablewidth",
      filterable: false,
      Cell: (cell) => {
        return (
          <KisshtLink
          to={`${ROUTES_VAR.transactions}/${cell.value}`}
          permission={PERMISSIONS.emandate_registration.transaction_view}
          route={ROUTE_NAME.emandate_registration}
          style={{ color: Colors.purple_400 }}
        >
          {cell.value}
        </KisshtLink>
        );
      },
    },
    {
      Header: "User Reference Number",
      accessor: "user_reference_number",
      sortable: false,
      headerClassName: "common_medium_tablewidth",
      filterable: false,
      Cell: (cell) => {
        return (
          <KisshtLink
            to={`${ROUTES_VAR.users}/${cell.value}`}
            permission={PERMISSIONS.emandate_registration.user_view}
            route={ROUTE_NAME.emandate_registration}
            style={{ color: Colors.purple_400 }}
          >
            {cell.value}
          </KisshtLink>
        );
      },
    },
    {
      Header: "Emandate Reference Number",
      accessor: "emandate_reference_number",
      sortable: false,
      filterable: false,
      Cell: (cell) => {
        return <span>{cell.value}</span>;
      },
    },
    {
      Header: "Merchant Reference Number",
      accessor: "merchant_reference_number",
      sortable: false,
      filterable: false,
      Cell: (cell) => {
        return <span>{cell.value}</span>;
      },
    },
    // {
    //   Header: "Partner Payment Id",
    //   accessor: "payment_amount",
    //   sortable: false,
    //   filterable: false,
    //   Cell: (cell) => {
    //     return <span>{cell.value}</span>;
    //   },
    // },
    {
      Header: "Mode",
      accessor: "auth_method",
      sortable: false,
      headerClassName: "common_small_tablewidth",
      filterable: false,
      Cell: (cell) => {
        return <span>{cell.value.toUpperCase()}</span>;
      },
    },
    // {
    //   Header: "Bank Api Response",
    //   accessor: "account_name",
    //   sortable: false,
    //   filterable: false,
    //   Cell: (cell) => {
    //     return <span>{cell.value}</span>
    //   },
    // },
    {
      Header: "Status",
      accessor: "status",
      sortable: false,
      width: "40",
      filterable: false,
      Cell: (cell) => {
        return <BootstrapBadge text={cell.value} />;
      },
    },
    {
      Header: "Time Stamp",
      accessor: "retry_timestamp",
      sortable: false,
      headerClassName: "common_small_tablewidth",
      filterable: false,
      Cell: (cell) => {
        return <span>{cell.value || "-"}</span>;
      },
    },
  ];
  const onPageChange = (value) => {
    offset = value;
    fetchEmandateListing();
  };

  const formDateHandle = (e) => {
    const formated_date = DateHandle(e);
    setFromDate(formated_date);
  };

  const toDateHandle = (e) => {
    const formated_date = DateHandle(e);
    setToDate(formated_date);
  };

  const handleSearch = () => {
    offset = 1;
    fetchEmandateListing();
  };
  const handleStatus = async (e) => {
    e.persist();
    if (e) {
      let item = e.target.value;
      if (!item) {
        setstatus("");
        await delteQueryParams();
      } else {
        setstatus(item);
      }
    }
  };
  const OnHandleSearch = (e) => {
    const validation_msg = filterValidation(selected, e.target.value);
    setSearch(e.target.value);
    setErrorMessage(validation_msg);
  };
  const handleAuthMode = async (e) => {
    e.persist();
    let item = e.target.value;
    if (!item) {
      setAuthMode("");
    } else {
      setAuthMode(item);
    }
  };

  const handleSelect = async (e) => {
    e.persist();
    if (e) {
      let item = e.target.value;
      if (!item) {
        setErrorMessage("");
        await delteQueryParams();
        setReload(!reload);
      }
      setSelected(item);
      setSearch("");
    }
  };
  const refreshHandler = async () => {
    setSearch("");
    setSelected("");
    setstatus("");
    setAuthMode("");
    setFromDate(null);
    setToDate(null);
    setEmdateData([])
    await delteQueryParams(); 
    offset = 1;
    setReload(!reload); 
  };

  return (
    <>
      <Header open={props.open}>
        <Toolbar
          style={{
            backgroundColor: Colors["AppBarBGPurple"],
            minHeight: "65px",
          }}
        >
          <GlobalHeader />
        </Toolbar>
        <Toolbar>
          <Grid container alignItems="center" className="crum_padding">
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Grid item>
                  <BreadcrumbsHeader text="Emandate Registartion" />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} className="crum_innerPadding">
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                  <CustomSelect
                    onChange={handleStatus}
                    nulloption="Select Status"
                    value={status}
                    options={{
                      pending: "pending",
                      created: "created",
                      authorized: "authorized",
                      captured: "captured",
                      soft_failed: "soft_failed",
                      failed: "failed",
                      inactive:"inactive"
                    }}
                    className="common_global_filter"
                  />
                </Grid>
                <Grid item>
                  <CustomSelect
                    nulloption="Select Mode"
                    multiple={false}
                    onChange={handleAuthMode}
                    value={authmode}
                    options={{
                      netbanking: "NetBanking",
                      debitcard: "DebitCard",
                    }}
                    className="common_global_filter"
                  />
                </Grid>
                <CustomSelect
                  onChange={handleSelect}
                  nulloption="Select Filter Options"
                  value={selected}
                  options={{
                    emandate_reference_number: "Mandate Reference Number",
                    user_reference_number: "User Reference Number",
                    transaction_reference_number:
                      "Transaction Reference Number",
                  }}
                  className="common_global_filter"
                />
                <Grid item style={{ position: "relative" }}>
                  <Grid>
                    <CustomInput
                      placeholder="Search"
                      onChange={(e) => OnHandleSearch(e)}
                      value={search}
                      className="common_custom_input"
                    />
                  </Grid>
                  <Grid>
                    {search ? (
                      <span className="validation_style_split">
                        {errorMessage}
                      </span>
                    ) : (
                      ""
                    )}
                  </Grid>
                </Grid>

                <Grid
                  item
                  lg={8}
                  md={8}
                  sm={12}
                  xs={12}
                  className={search ? "margin_top_split_mobile" : ""}
                >
                  <Grid container spacing={1} alignItems="center">
                    <Grid item>
                      <label className="from-to-date-label">From Date</label>
                      <DatePicker
                        placeholder="Select From Date"
                        className="date_style"
                        format="yyyy-MM-dd"
                        disableFuture
                        renderInput={(fromDateProps) => (
                          <TextField
                            {...fromDateProps}
                            style={{ color: "#e2e8f0" }}
                          />
                        )}
                        onChange={(e) => formDateHandle(e)}
                        value={fromDate}
                      />
                    </Grid>
                    <Grid item>
                      <label className="from-to-date-label">To Date</label>
                      <DatePicker
                        placeholder="Select To Date"
                        className="date_style"
                        disableFuture
                        format="yyyy-MM-dd"
                        renderInput={(toDateProps) => (
                          <TextField
                            {...toDateProps}
                            style={{ color: "#e2e8f0" }}
                          />
                        )}
                        onChange={(e) => toDateHandle(e)}
                        value={toDate}
                      />
                    </Grid>
                    <Grid item>
                      <Button
                        size="small"
                        variant="contained"
                        className="shadow-none common_kissht_btn"
                        color="primary"
                        onClick={handleSearch}
                        disabled={
                          (fromDate?.length > 0 && toDate?.length > 0) ||
                          status ||
                          (selected && search) ||
                          (authmode && !errorMessage)
                            ? false
                            : true
                        }
                      >
                        Search
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        onClick={() => refreshHandler()}
                        size="small"
                        color="primary"
                      >
                        Reset
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Toolbar>
      </Header>
      <div
        className={
          search
            ? "padding_top_mobile"
            : "common_paddingTop_from_title_withFilter"
        }
      >
        <Card
          style={{
            boxShadow: `0px 3px 6px ${Colors["LightPurpleShadow"]}`,
          }}
        >
          <CardContent style={{ height: "50px" }}>
            <Grid container className="grid-vertical-align-center">
              <Grid item xs={12}>
                <p
                  className="text-xs"
                  style={{
                    color: Colors["lightPurple"],
                    margin: "auto",
                  }}
                ></p>
              </Grid>
            </Grid>
          </CardContent>
          <CardContent className="table_card_mobile">
            <KisshtTable
              loading={spinning}
              columns={columns}
              data={emandateData}
              onPageChange={onPageChange}
              showPagination={emandateData.length > 0 ? true : false}
              offset={offset}
              totalCount={emdateCount}
            />
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default EmandateRegistration;
